import { createContext } from 'react'

interface AppContextType {
  isLeader: boolean
  setIsLeader: (isLeader: boolean) => void
  isAppLoading: boolean
  isDbLoading: boolean
  setIsDbLoading: (isDbLoading: boolean) => void
  hasAppError: boolean
  setHasAppError: (hasAppError: boolean) => void
}

const defaultValue: AppContextType = {
  isLeader: false,
  setIsLeader: () => {
    throw new Error('setIsLeader must be implemented in the provider.')
  },
  isAppLoading: true,
  isDbLoading: true,
  setIsDbLoading: () => {
    throw new Error('setIsDbLoading must be implemented in the provider.')
  },
  hasAppError: false,
  setHasAppError: () => {
    throw new Error('setHasAppError must be implemented in the provider.')
  },
}

// Create the context with undefined as a valid initial value
export const AppContext = createContext<AppContextType>(defaultValue)
